import { PolicyType } from '@practium/features/policy';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

interface RequestActivatePolicyParams {
	id: string;
	policyType: PolicyType;
}

export function useActivatePolicy() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, policyType }: RequestActivatePolicyParams) => {
			try {
				return (
					await api.post('/management/policy-version/active', {
						policyVersionId: id,
						policyType,
					})
				).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao ativar política');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['policies'] });
		},
		onError: (error) => {
			console.error(
				'Erro ao atualizar o estado do termo:',
				getApiErrorMessage(error, 'Erro ao atualizar o estado do termo.')
			);
		},
	});
}
